import LogList from 'common/pages/log/LogList.tsx'

export const LogListAdmin = (props: any) => <LogList {...props} admin />